export function getChatDialogStyles() {
  return {
    container: {
      position: 'fixed',
      bottom: 30,
      right: 30,
      width: 250,
      padding: '30px 15px 30px 15px',
      textAlign: 'center',
      fontSize: '13px',
      lineHeight: '1.333em',
      backgroundColor: 'white',
      boxShadow: '0 2px 6px rgb(0 0 0 / 30%)',
      zIndex: 10400,
    },
    header: {
      position: 'absolute',
      top: 0,
      left: 0,
      display: 'block',
      width: '100%',
      height: 70,
      backgroundColor: '#0078d4',
    },
    agentAvatar: {
      position: 'relative',
      display: 'inline-block',
      width: 75,
      height: 75,
      backgroundColor: '#d2d2d2',
      borderRadius: '50%',
    },
    subTitle: {
      margin: '0px 0px 15px 0px',
    },
    button: {
      color: 'white',
      width: '75%',
      marginBottom: '15px',
      display: 'inline-block',
      textDecoration: 'none',
      minHeight: '32px',
      padding: '6px 17px 6px 17px',
      lineHeight: 1.333,
      textAlign: 'center',
      verticalAlign: 'middle',
      cursor: 'pointer',
      backgroundClip: 'unset',
      borderRadius: 0,
      border: 'none',
      outline: '1px dashed transparent',
      outlineOffset: 0,
      '&:focus': {
        outlineColor: 'currentColor !important',
        outlineOffset: '-3px !important',
      },
    },
    chatNowButton: {
      backgroundColor: '#0078d4',
      '&:hover': {
        backgroundColor: '#243a5e',
      },
      '&:focus': {
        backgroundColor: '#243a5e',
      },
    },
    rejectButton: {
      backgroundColor: '#737373',
      '&:hover': {
        backgroundColor: '#2f2f2f',
      },
      '&:focus': {
        backgroundColor: '#2f2f2f',
      },
    },
  };
}
